(() => {
  window.DigitalizModules = window.DigitalizModules || {};
  if (window.DigitalizModules.predictiveSearch) return;
  window.DigitalizModules.predictiveSearch = true;

  const MIN_QUERY_LENGTH = 2;

  function typeLabel(type) {
    if (!window.themeStrings) return type;
    if (type === "product") return window.themeStrings.predictiveTypeProduct || type;
    if (type === "collection") return window.themeStrings.predictiveTypeCollection || type;
    if (type === "page") return window.themeStrings.predictiveTypePage || type;
    if (type === "article") return window.themeStrings.predictiveTypeArticle || type;
    return type;
  }

  function renderResults(container, data) {
    container.innerHTML = "";

    const products = data?.resources?.results?.products || [];
    const pages = data?.resources?.results?.pages || [];
    const articles = data?.resources?.results?.articles || [];
    const collections = data?.resources?.results?.collections || [];

    const items = [
      ...products.map((item) => ({ type: "product", title: item.title, url: item.url })),
      ...collections.map((item) => ({ type: "collection", title: item.title, url: item.url })),
      ...pages.map((item) => ({ type: "page", title: item.title, url: item.url })),
      ...articles.map((item) => ({ type: "article", title: item.title, url: item.url }))
    ];

    if (!items.length) {
      const msg = document.createElement("p");
      msg.className = "small m-0";
      msg.textContent = window.themeStrings?.predictiveEmpty || "No results found.";
      container.appendChild(msg);
      return;
    }

    const ul = document.createElement("ul");
    ul.className = "list-unstyled m-0";

    items.slice(0, 8).forEach((item) => {
      const li = document.createElement("li");
      li.className = "predictive-search-item";

      const a = document.createElement("a");
      a.href = item.url;
      a.textContent = item.title;

      const badge = document.createElement("span");
      badge.className = "small text-muted";
      badge.textContent = ` (${typeLabel(item.type)})`;

      li.appendChild(a);
      li.appendChild(badge);
      ul.appendChild(li);
    });

    container.appendChild(ul);
  }

  async function fetchPredictive(query) {
    const params = new URLSearchParams({
      q: query,
      "resources[type]": "product,page,article,collection",
      "resources[limit]": "8"
    });
    const response = await fetch(`/search/suggest.json?${params.toString()}`, {
      headers: { Accept: "application/json" }
    });
    if (!response.ok) throw new Error("Predictive search failed");
    return response.json();
  }

  function getResultLinks(container) {
    return [...container.querySelectorAll("a")];
  }

  function bind(input) {
    if (input.dataset.predictiveBound === "true") return;
    input.dataset.predictiveBound = "true";

    const targetId = input.getAttribute("data-predictive-target");
    const target = targetId ? document.getElementById(targetId) : null;
    if (!target) return;

    let currentToken = 0;

    input.addEventListener("input", async () => {
      const query = input.value.trim();
      const token = ++currentToken;

      if (query.length < MIN_QUERY_LENGTH) {
        target.hidden = true;
        target.innerHTML = "";
        return;
      }

      try {
        const data = await fetchPredictive(query);
        if (token !== currentToken) return;
        renderResults(target, data);
        target.hidden = false;
      } catch (error) {
        target.hidden = true;
      }
    });

    // Keyboard navigation: ArrowDown/Up moves focus through results; Escape closes.
    input.addEventListener("keydown", (event) => {
      if (target.hidden) return;

      if (event.key === "ArrowDown") {
        event.preventDefault();
        const links = getResultLinks(target);
        if (links.length) links[0].focus();
      } else if (event.key === "Escape") {
        target.hidden = true;
        input.focus();
      }
    });

    target.addEventListener("keydown", (event) => {
      const links = getResultLinks(target);
      const focused = document.activeElement;
      const index = links.indexOf(focused);

      if (event.key === "ArrowDown") {
        event.preventDefault();
        if (index < links.length - 1) links[index + 1].focus();
      } else if (event.key === "ArrowUp") {
        event.preventDefault();
        if (index <= 0) {
          input.focus();
        } else {
          links[index - 1].focus();
        }
      } else if (event.key === "Escape") {
        target.hidden = true;
        input.focus();
      }
    });

    document.addEventListener("click", (event) => {
      if (!(event.target instanceof Node)) return;
      if (!target.contains(event.target) && event.target !== input) {
        target.hidden = true;
      }
    });
  }

  function init() {
    document.querySelectorAll("[data-predictive-search-input]").forEach(bind);
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
